import { render } from "./AdsList.vue?vue&type=template&id=6da4c26f&scoped=true"
import script from "./AdsList.vue?vue&type=script&lang=js"
export * from "./AdsList.vue?vue&type=script&lang=js"

import "./AdsList.vue?vue&type=style&index=0&id=6da4c26f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da4c26f"]])

export default __exports__